// What each Staff Portal tier unlocks. Mirrors the shape of crm-app's
// services/plans.js so the two products read the same way.
//
// Two tiers, both time-limited — this is a demo deployment, not a product
// installation:
//
//   free  1 month, granted automatically on Google sign-in from the site.
//         The everyday employee portal: news, chat, org chart, profile,
//         gallery, HR information, vacancies, learning.
//   demo  3 months, granted after registering inside the portal and confirming
//         a code. Adds the management side — the daily operations report, staff
//         accommodation, the employee survey, and the admin tools that go with
//         running a hotel rather than working in one.
//
// The split is deliberate: everything a visitor needs to judge whether the
// portal is pleasant to USE is free, and the modules a manager would need to
// judge whether to BUY it are what the registration buys. Gating the pretty
// parts would just make the free tier feel broken.

export const PLAN = {
  FREE: "free",
  DEMO: "demo",   // the 3-month trial
  TRIAL: "trial", // legacy alias, treated as demo
  PRO: "pro",     // a real licensed installation
};

export const FEATURE = {
  DAILY_REPORT: "daily_report",
  STAFF_HOUSE: "staff_house",
  SURVEY: "survey",
  USER_ACCESS: "user_access",
  MESSAGING: "messaging",       // SMS + push + admin messaging
  ADMIN_PEOPLE: "admin_people", // users, allowed IDs, working hours, logs
};

const ALL = Object.values(FEATURE);

export const PLAN_FEATURES = {
  [PLAN.FREE]: [],
  [PLAN.DEMO]: ALL,
  [PLAN.TRIAL]: ALL,
  [PLAN.PRO]: ALL,
};

export const PLAN_DAYS = {
  [PLAN.FREE]: 30,
  [PLAN.DEMO]: 90,
};

export function planLabel(plan) {
  switch (plan) {
    case PLAN.PRO: return "Pro";
    case PLAN.DEMO:
    case PLAN.TRIAL: return "Trial";
    case PLAN.FREE:
    default: return "Free";
  }
}

// Shown on the upgrade card, so the visitor can see what registering buys
// before they type anything.
export const LOCKED_MODULES = [
  { feature: FEATURE.DAILY_REPORT, label: "Daily Operations Report", blurb: "The night audit, F&B revenue by outlet, guest scores and the full incident log." },
  { feature: FEATURE.STAFF_HOUSE, label: "Staff Accommodation", blurb: "Houses, rooms, residents, housekeeping status and maintenance tickets." },
  { feature: FEATURE.SURVEY, label: "Employee of the Month", blurb: "Nominations, voting, winners, badges and the history behind them." },
  { feature: FEATURE.MESSAGING, label: "SMS & push notifications", blurb: "Message the whole team or one department, with delivery history." },
  { feature: FEATURE.ADMIN_PEOPLE, label: "Staff administration", blurb: "Users and permissions, working-hours approval, and the activity log." },
  { feature: FEATURE.USER_ACCESS, label: "User access requests", blurb: "The HR → General Manager approval flow for new system accounts." },
];
